import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Gift, User, LogOut, Wallet } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import { getAccountMenuItems } from '../lib/accountMenu';
import { adminShortcutVisible } from '../lib/adminDomain';
import { useActiveTheme } from '../lib/activeTheme';

const UserDropdown = () => {
  const {
    user, balance, bonusBalance, logout,
  } = useAuth();
  const settings = useSettings();
  const themeId = useActiveTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  if (!user) return null;

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => !v)} className="side-icon-btn inline-flex" aria-label="Hesap">
        <User size={18} />
      </button>
      {open && (
        <div className="user-account-dropdown absolute right-0 mt-3 w-72 pusu-panel z-50 overflow-hidden shadow-2xl">
          <div className="p-4 flex items-center gap-3 border-b border-white/5">
            <div className="w-11 h-11 rounded-lg flex items-center justify-center font-black text-sm" style={{ background: 'linear-gradient(180deg, var(--pusu-accent-light), var(--pusu-gold-2))', color: 'var(--pusu-on-accent)' }}>
              {user.initials}
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold">{user.username}</div>
              <div className="mt-1 px-2 py-1 inline-flex items-center gap-1.5 rounded-md text-xs" style={{ background: 'var(--pusu-card)', border: '1px solid var(--pusu-border)' }}>
                <Wallet size={12} className="text-[var(--pusu-gold)]" />
                <span className="gold-text font-bold">{balance.toFixed(2)} ₺</span>
              </div>
              <div className="mt-1 ml-1 px-2 py-1 inline-flex items-center gap-1.5 rounded-md text-xs" style={{ background: 'var(--pusu-card)', border: '1px solid var(--pusu-border)' }}>
                <Gift size={12} className="text-yellow-400" />
                <span className="font-bold text-yellow-400">{bonusBalance.toFixed(2)} ₺</span>
              </div>
            </div>
          </div>
          <div className="py-2">
            {getAccountMenuItems(user, {
              sportsEnabled: settings.sports_enabled !== false,
              adminVisible: adminShortcutVisible(settings),
              themeId,
            }).map(({
              to, icon: Icon, label, admin,
            }) => (
              <Link
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                  admin
                    ? 'mx-2 mb-1 rounded-lg border border-[var(--pusu-gold)]/30 bg-[var(--pusu-gold)]/10 text-[var(--pusu-accent-light)] hover:bg-[var(--pusu-gold)]/15'
                    : 'text-gray-200 hover:bg-white/5 hover:text-[var(--pusu-accent-light)]'
                }`}
              >
                <Icon size={16} className="text-[var(--pusu-gold)]" aria-hidden="true" />
                {label}
              </Link>
            ))}
            <div className="h-px bg-white/5 my-1" />
            <button onClick={() => { logout(); setOpen(false); nav('/'); }} className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-white/5 text-sm text-gray-200 hover:text-red-400 transition-colors">
              <LogOut size={16} className="text-red-400" /> Çıkış Yap
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
